import { render, staticRenderFns } from "./ChatStatistics.vue?vue&type=template&id=b52f3e9e&scoped=true&"
import script from "./ChatStatistics.vue?vue&type=script&lang=js&"
export * from "./ChatStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ChatStatistics.vue?vue&type=style&index=0&id=b52f3e9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f3e9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
